import ResourcesSearch from '../modules/resources-search'
import FullsiteSearch from '../modules/fullsite-search'

export default class App {
    constructor() {
    }

    init() {
        this.detectSearch();
    }

    detectSearch() {
        let resourcesSearchElement = document.getElementById("resources-search");
        if (resourcesSearchElement != null) {
            let resourcesSearch = new ResourcesSearch(resourcesSearchElement);
            resourcesSearch.init();
            return;
        }

        let fullsiteSearchElement = document.getElementById("full-site-search");
        if (fullsiteSearchElement !=null) {
            let fullsiteSearch = new FullsiteSearch(fullsiteSearchElement);
            fullsiteSearch.init();
            return;
        }
    }
}